import "./Login.css";
import { useForm } from "react-hook-form";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from "react";

const Login = (props) => {
    const naviget = useNavigate()
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [error, setError] = useState("")
    const [msg, setMsg] = useState("")
    const [user, setUser] = useState("")

    useEffect(() => {
        let login = localStorage.getItem("login")

        if (login) {
            naviget("/ingreso")
        }
        let loginStatus = localStorage.getItem("loginStatus")
        if (loginStatus) {
            setError(loginStatus)
            setTimeout(() => {
                localStorage.clear()
                window.location.reload()
            }, []);
        }
        /*setTimeout(function(){
            setMsg("")
        }, [])*/
    }, [msg])

    const onSubmit = data => {
        setUser(data.usuario)
        console.log(errors)
        axios.post("https://cootransfusa.com/mantenimiento-cootransfusa/", data, {
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if (!response.data.sesion) {
                setMsg("Usuario y/o contraseña incorrectos")
            } else {
                props.handleDataReceivedSesion(data.usuario)
                //localStorage.setItem("login", true)
                localStorage.setItem("login", data.usuario)
                setTimeout(function(){
                    naviget("/ingreso")
                }, [])
            }
        })
        .catch(error => {
            console.error(error);
        });
    };

    return(
        <div className="login">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className='login_logo'><img src="./img/logo-blanco.png" alt="" /></div>
                <div className="login_title"><p>inspección preoperacional de vehículos livianos</p></div>

                <div onSubmit={props.ingresar} className='login_inputs'>
                    <p><input type="text" placeholder='Usuario' name="usuario" required {...register("usuario",{required: true,})}/></p>
                    <p><input type="password" placeholder='Contraseña' name="pass" required {...register("pass",{required: true,})}/></p>
                    <p><input type="submit" className="login_submit" value={"iniciar sesión"}/></p>
                </div>
                <p className={msg ? "login_incorrect":""}>{msg}</p>
            </form>
        </div>

    )
}

export default Login